<template>
  <div class="addcourse">
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <a-button type="primary" @click="editCourse">保存课程</a-button>
      <!-- <a-button type="primary" v-if="id" @click="publish">发布课程</a-button> -->
      <a-button @click="returnBack">返回</a-button>
    </div>
    <h3>课程基本信息</h3>
    <div class="section">
      <a-row type="flex">
        <a-col :flex="5" v-if="userRole == 'youwei_admin'">
          <span><span style="color: red">*</span>所属公司：</span>
          <a-tree-select style="width: 160px; margin-right: 10px" v-model="formData.companyId" allowClear
            :disabled="id != 0 && issueFlag != 0" :treeData="companyList" :show-checked-strategy="SHOW_PARENT"
            placeholder="所属公司" :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            maxTagCount="1" @change="companychange">
          </a-tree-select>
        </a-col>
        <a-col :span="userRole == 'youwei_admin'?5:6">
          <span><span style="color: red">*</span>课程类别：</span>
          <a-select v-model="formData.trainId" placeholder="请选择" :disabled="id != 0 && issueFlag != 0" showSearch
            optionFilterProp="label" :style="userRole == 'youwei_admin'?'width: 160px;':'width: 210px;'">
            <a-select-option :value="item.id" v-for="(item, index) in categoryList" :key="index"
              :label="item.categoryName">
              {{ item.categoryName }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="userRole == 'youwei_admin'?5:6">
          <span><span style="color: red">*</span>课程名称：</span>
          <a-input placeholder="请输入" v-model="formData.courseName"
            :disabled="(id != 0 && issueFlag != 0) && userRole!='youwei_admin'"
            :style="userRole == 'youwei_admin'?'width: 160px;':'width: 210px;'" />
        </a-col>
        <a-col :span="userRole == 'youwei_admin'?5:6">
          <span><span style="color: red">*</span>必修部门：</span>
          <a-tree-select :style="userRole == 'youwei_admin'?'width: 160px;':'width: 210px;'" v-model="formData.deptId"
            allowClear :treeData="deptLists" tree-checkable :show-checked-strategy="SHOW_PARENT" placeholder="请选择"
            :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1"
            @change="deptchange" :disabled="(id != 0 && issueFlag != 0) && userRole!='youwei_admin'">
          </a-tree-select>
        </a-col>
        <a-col :span="userRole == 'youwei_admin'?4:6">
          <span><span style="color: red">*</span>学时：</span>
          <a-input type="number" @change="inputChange" placeholder="请输入" v-model="formData.classHour"
            :style="userRole == 'youwei_admin'?'width: 160px;':'width: 210px;'" />
        </a-col>
      </a-row>
      <!-- <a-row type="flex">
        <a-col :span="6">
          <span>是否为必修课程：</span>
          <a-switch v-model="formData.recommend" @change="onChange" />
        </a-col>
      </a-row> -->
    </div>
    <h3>课程资料</h3>
    <div class="section">
      <div style="position: relative;width:240px;160px">
        <div class="uploadBox" id="picker" v-show="!formData.md5">
          <a-icon type="cloud-upload" />
        </div>
        <div class="cantupload"
          v-if="!formData.trainId || !formData.deptId.length || !formData.classHour || !formData.courseName"
          @click.stop="cantuploadVideo"></div>
      </div>
      <div class="uploadBox" v-show="formData.md5" @click="previewVideo">
        <a-icon type="close-circle" class="delImg" @click.stop="delFile" v-show="formData.md5" />
        <a-icon type="play-circle" class="showVideo" v-show="formData.md5" />
        <div class="showImg" v-show="formData.md5"></div>
      </div>
      <!-- <div v-if="isContinueUpload">
        检测到中断的文件（{{ continueFileINfo.name }}）上传，是否<a-button type="link" @click="continueUpload()">
          重新上传 </a-button
        ><a-button type="link" @click="cancelContinue()"> 取消 </a-button>
      </div> -->
      <div v-if="uploading">
        正在上传中{{ fileName ? '（' + fileName + '）' : '' }}（{{ percentage }}%）
        <a-icon type="loading" />
      </div>
      <div v-if="!uploading && formData.md5">
        <template v-if="fileName"> 上传成功：{{ fileName }} </template>
        <template v-else> 已上传视频 </template>
      </div>
      <div style="width: 0; height: 0"></div>
      <input type="file" style="width: 0; height: 0; opacity: 0" ref="refChange" @change="fileChange($event)" />
    </div>
  </div>
</template>

<script>
import { getCueseInfo, saveCueseInfo, getCategoryLis, changeCueseInfo } from '../../../api/course'
import { tree_all } from '../../../api/purchase'
import { training_video_log } from '../../../api/question'
import WebUploader from 'webuploader'
export default {
  data() {
    return {
      formData: {
        companyId: undefined,
        trainId: undefined,
        courseName: '',
        deptId: [],
        classHour: '',
        md5: '',
        recommend: false,
      },
      id: '',
      issueFlag: '',
      deptLists: [],
      categoryList: [],
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      userInfo: {},
      uploader: null,
      uploading: false,
      fileName: '',
      fileInfo: {},
      md5: '',
      percentage: 0,
      isContinueUpload: false,
      continueFileINfo: {},
      userRole: '',
      companyList: [],
      deptObj: {},
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.getDeptLists()
    if (this.userRole == 'youwei_admin') {
    } else {
      this.getCategoryList()
    }
    this.uploadInit()
    this.select = this.$route.query.select
    if (!'this.$route.query.uploading') {
      this.id = Number(this.$route.query.id)
      getCueseInfo({ id: Number(this.$route.query.id) }).then((res) => {
        if (res.code != 200) {
          return
        }
        this.issueFlag = res.data.issueFlag
        this.formData.trainId = res.data.trainId
        this.formData.courseName = res.data.courseName
        this.formData.deptId = res.data.deptId.split(',')
        this.formData.classHour = res.data.classHour
        this.formData.recommend = res.data.recommend ? 1 : 0
        this.md5 = res.data.md5
        this.isContinueUpload = true
        this.continueFileINfo = this.$store.getters.uploadFileInfo
        this.$store.commit('SET_Upload_Status', 'end')
      })
    } else if (this.$route.query.id) {
      this.id = Number(this.$route.query.id)
      getCueseInfo({ id: Number(this.$route.query.id) }).then((res) => {
        if (res.code != 200) {
          return
        }
        this.issueFlag = res.data.issueFlag
        this.formData.trainId = res.data.trainId
        this.formData.courseName = res.data.courseName
        this.formData.deptId = res.data.deptId.split(',')
        this.formData.classHour = res.data.classHour
        this.formData.recommend = res.data.recommend ? 1 : 0
        this.formData.md5 = res.data.md5
        this.formData.companyId = res.data.companyId
        this.md5 = res.data.md5
        this.getCategoryList(res.data.companyId)
        if (this.userRole == 'youwei_admin') {
          tree_all().then((res) => {
            this.deptLists = []
            res.data[0].forEach((item) => {
              if (item.deptId == this.formData.companyId) {
                this.deptLists = item.children
              }
            })
          })
        }
      })
    }
  },
  beforeDestroy() {
    if (this.uploading && this.id) {
      this.$store.commit('SET_Upload_Status', 'uploading')
      this.fileInfo.courseId = this.id
      this.$store.commit('SET_Upload_Info', this.fileInfo)
      this.uploader.stop(true)
    }
  },
  methods: {
    companychange() {
      this.getCategoryList(this.formData.companyId)
      this.formData.deptId = []
      this.formData.trainId = undefined
      tree_all().then((res) => {
        this.deptLists = []
        res.data[0].forEach((item) => {
          if (item.deptId == this.formData.companyId) {
            this.deptLists = item.children
          }
        })
      })
    },
    inputChange() {
      if (/^[0-9]+(\.[0-9]{1})?$/.test(this.formData.classHour)) {
        return
      }
      this.formData.classHour = ''
    },
    cantuploadVideo() {
      let params = JSON.parse(JSON.stringify(this.formData))
      if (!params.companyId && this.userRole == 'youwei_admin') {
        return this.$message.error('请选择所属公司')
      }
      if (!params.trainId) {
        return this.$message.error('请输入课程类别')
      }
      if (!params.courseName) {
        return this.$message.error('请输入课程名称')
      }
      if (!params.deptId.length) {
        return this.$message.error('请选择必修部门')
      }
      if (!params.classHour) {
        return this.$message.error('请输入学时')
      }
      // this.$refs.refChange.dispatchEvent(new MouseEvent('click'))
    },
    fileChange(e) {
      let input = e.target
      let file = e.target.files[0]
      input.value = ''
      console.log(file)
      let reader = new FileReader()
      reader.onload = (e) => {
        var arr = e.target.result.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        let fileblob = new Blob([u8arr], { type: mime })
        let wufile = new WebUploader.Lib.File(WebUploader.guid('rt_'), fileblob)
        wufile.name = file.name
        wufile = new WebUploader.File(wufile)
        wufile.setStatus('inited')
        this.uploader.addFiles(wufile)
        this.uploader.upload()
      }
      reader.readAsDataURL(file)
    },
    onChange(e) {
      console.log(e)
    },
    previewVideo() {
      let params = {
        courseId: this.formData.id,
        md5: this.formData.md5,
      }
      training_video_log(params).then((res) => {
        if (res.code != 200) {
          return
        }
        window.open(res.data.video)
      })
    },
    cancelContinue() {
      this.isContinueUpload = false
    },
    continueUpload() {
      this.isContinueUpload = false
      let file = new WebUploader.File(this.continueFileINfo.source.source)
      file.setStatus('inited')
      this.uploader.addFiles(file)
      this.uploader.upload()
    },
    uploadInit() {
      let _this = this
      if (this.uploader) {
        this.uploader.destroy()
      }
      console.log(WebUploader)
      WebUploader.Uploader.unRegister('initUploadVideo')
      WebUploader.Uploader.register(
        {
          name: 'initUploadVideo',
          // 在文件发送之前执行
          'before-send-file': 'beforeSendFile',
          // 在文件分片（如果没有启用分片，整个文件被当成一个分片）后，上传之前执行
          'before-send': 'beforeSend',
          // 在文件所有分片都上传完后，且服务端没有错误返回后执行
          'after-send-file': 'afterSendFile',
        },
        {
          beforeSendFile: function (file) {
            // console.log(file)
            this.isContinueUpload = false
            var startDate = new Date()
            console.log('开始上传时间' + startDate)
            console.log('beforeSendFile')
            _this.uploading = true
            _this.fileInfo = file
            // Deferred对象在钩子回掉函数中经常要用到，用来处理需要等待的异步操作。
            var deferred = WebUploader.Deferred()
            //1、计算文件的唯一标记MD5，用于断点续传
            _this.uploader
              .md5File(file, 0, 3 * 1024 * 1024)
              .progress(function (percentage) {
                // 上传进度
                console.log('上传进度:', percentage)
              })
              .then(function (val) {
                // 完成
                console.log('File MD5 Result:', val)
                file.md5 = val
                file.uid = WebUploader.Base.guid()
                // 判断文件是否上传过，是否存在分片，断点续传
                $.ajax({
                  type: 'POST',
                  url: process.env.VUE_APP_API_BASE_URL + '/file/file/check',
                  async: false,
                  data: {
                    fileMd5: val,
                  },
                  beforeSend: function (request) {
                    request.setRequestHeader('token', localStorage.getItem('Access-Token').replace(/"/g, ''))
                  },
                  success: function (res) {
                    if (res.data == -1) {
                      // 文件已经上传过,忽略上传过程，直接标识上传成功；
                      _this.$message.success('上传成功')
                      _this.formData.md5 = val
                      _this.fileName = file.name
                      _this.editCourse(1)
                      _this.uploader.skipFile(file)
                      file.pass = true
                    } else {
                      //文件没有上传过，下标为0
                      //文件上传中断过，返回当前已经上传到的下标
                      file.indexcode = res.data
                    }
                    deferred.resolve()
                  },
                })
              })
            return deferred.promise()
          },
          beforeSend: function (block) {
            //获取已经上传过的下标
            var indexchunk = block.file.indexcode
            var deferred = WebUploader.Deferred()
            if (indexchunk > 0) {
              if (block.chunk > indexchunk) {
                //分块不存在，重新发送该分块内容
                deferred.resolve()
              } else {
                //分块存在，跳过
                deferred.reject()
              }
            } else {
              //分块不存在，重新发送该分块内容
              deferred.resolve()
            }
            //返回Deferred的Promise对象。
            return deferred.promise()
          },
          afterSendFile: function (file) {
            console.log(file)
            _this.uploading = false
            //如果所有分块上传成功，则通知后台合并分块
            if (_this.formData.md5 && _this.formData.md5 == file.md5) {
              _this.fileName = file.name
              return
            }
            $.ajax({
              type: 'POST',
              url: process.env.VUE_APP_API_BASE_URL + '/file/file/merge',
              async: false,
              data: {
                fileName: file.name,
                fileMd5: file.md5,
              },
              beforeSend: function (request) {
                request.setRequestHeader('token', localStorage.getItem('Access-Token').replace(/"/g, ''))
              },
              success: function (res) {
                if (res.code !== 200) {
                  return _this.$message.error(res.msg)
                }
                _this.$message.success('上传成功')
                _this.formData.md5 = file.md5
                _this.fileName = file.name
                _this.editCourse(1)
              },
              error: function () { },
            })
          },
        }
      )
      _this.uploader = WebUploader.create({
        pick: {
          id: '#picker',
        },
        duplicate: true, //去重， 根据文件名字、文件大小和最后修改时间来生成hash Key
        swf: './Uploader.swf',
        chunked: true,
        chunkSize: 10 * 1024 * 1024, // 10M 每个分片的大小限制
        threads: 3,
        server: process.env.VUE_APP_API_BASE_URL + '/file/file/partial_upload',
        headers: {
          token: localStorage.getItem('Access-Token').replace(/"/g, ''),
        },
        auto: true,
        // 禁掉全局的拖拽功能。这样不会出现图片拖进页面的时候，把图片打开。
        disableGlobalDnd: true,
        fileNumLimit: 1024,
        fileSizeLimit: 50 * 1024 * 1024 * 1024, //50G 验证文件总大小是否超出限制, 超出则不允许加入队列
        fileSingleSizeLimit: 10 * 1024 * 1024 * 1024, //10G 验证单个文件大小是否超出限制, 超出则不允许加入队列
        accept: {
          extensions: 'avi,wmv,mpeg,mp4,m4v,mov,asf,flv,f4v,rmvb,rm,3gp,vob',
          mimeTypes: 'video/*,audio/*,aplication/*',
        },
      })
      _this.uploader.on('fileQueued', function (file) { })
      //当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次。
      _this.uploader.on('uploadBeforeSend', function (obj, data, headers) {
        console.log('onUploadBeforeSend--------------')
        console.log(obj)
        console.log(data)
        data.uid = _this.userInfo.userId
        data.chunks = obj.chunks
        data.chunk = obj.chunk + 1
        data.size = obj.end - obj.start
        data.name = data.name
        data.md5 = obj.file.md5 || ''
      })
      // 上传中
      _this.uploader.on('uploadProgress', function (file, percentage) {
        _this.percentage = parseInt(percentage * 100)
      })
      // 上传返回结果
      _this.uploader.on('uploadStart', function (file) {
        // console.log(file, 'uploadStart')
      })
      _this.uploader.on('uploadSuccess', function (file) { })
      _this.uploader.on('uploadError', function (file) { })
      _this.uploader.on('uploadComplete', function (file) { })
    },
    getCategoryList(companyId) {
      getCategoryLis({ companyId: companyId }).then((res) => {
        if (res.code != 200) {
          return
        }
        this.categoryList = res.data.list
      })
    },
    delFile() {
      this.formData.md5 = ''
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        this.deptLists = []
        if (this.userRole == 'youwei_admin') {
          let deptObj = {}
          let data = res.data[0]
          for (let i = 0; i < data.length; i++) {
            deptObj[data[i].deptId] = data[i]
          }
          this.deptObj = deptObj
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.companyList = data
        } else {
          res.data[0].forEach((item) => {
            if (item.deptId == this.userInfo.companyId) {
              this.deptLists = item.children
            }
          })
        }
      })
    },
    editCourse(returnBack) {
      let params = JSON.parse(JSON.stringify(this.formData))
      if (!params.companyId && this.userRole == 'youwei_admin') {
        return this.$message.error('请选择所属公司')
      }
      if (!params.trainId) {
        return this.$message.error('请输入课程类别')
      }
      if (!params.courseName) {
        return this.$message.error('请输入课程名称')
      }
      if (!params.deptId.length) {
        return this.$message.error('请选择必修部门')
      }
      if (!params.classHour) {
        return this.$message.error('请输入学时')
      }
      for (let i = 0; i < this.categoryList.length; i++) {
        if (this.categoryList[i].id == params.trainId) {
          params.trainType = this.categoryList[i].categoryName
          break
        }
      }
      params.deptId = params.deptId.join(',')
      params.recommend = params.recommend ? 1 : 0
      if (this.id) {
        params.id = this.id
        if (this.md5 == params.md5) {
          delete params.md5
        }
        changeCueseInfo(params).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          if (returnBack == 1) {
            return
          }
          this.$router.push({
            path: '/training/course?select=' + this.select,
          })
        })
      } else {
        saveCueseInfo(params).then((res) => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          if (returnBack == 1) {
            this.id = Number(res.data)
            return
          }
          this.$router.push({
            path: '/training/course?select=' + this.select,
          })
        })
      }
    },
    returnBack() {
      this.$router.push({
        path: '/training/course?select=' + this.select,
      })
    },
  },
}
</script>

<style scoped lang="less">
.addcourse {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0 6px 30px;
  h3 {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .section {
    width: 100%;
    padding: 20px 30px;
    box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    margin-bottom: 10px;
    .ant-row-flex {
      margin-bottom: 8px;
    }
    /deep/ .ant-btn-link {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
  .cantupload {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    cursor: pointer;
  }
  .uploadBox {
    width: 240px;
    height: 160px;
    border-radius: 8px;
    border: 1px dashed #ccc;
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    color: #108ee9;
    position: relative;
    cursor: pointer;
    .hiddenInput {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      z-index: 9;
    }
    .delImg {
      position: absolute;
      right: -6px;
      top: -6px;
      font-size: 20px;
      color: red;
      z-index: 10;
      cursor: pointer;
    }
    .showVideo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      font-size: 36px;
      color: #fff;
      z-index: 14;
      cursor: pointer;
    }
    .showImg {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url('../../../assets/videoBackground.png');
      border-radius: 8px;
    }
    /deep/ div[id^='rt_'] {
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: 100% !important;
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 9;
        font-size: 0;
      }
    }
  }
}
</style>